import { formatDate } from "@angular/common";
import { UntypedFormGroup, Validators } from "@angular/forms";
import * as moment from "moment";
import { Observable } from "rxjs"
import { MateriaMin } from "src/app/unidad-buscar/models/unidad-setup"

export class ClasePerdida {
  constructor(form?: UntypedFormGroup) {
    const model = form?.value;
    this.id = model?.id ?? 0;
    this.unidadID = model?.unidadID ?? 0;
    this.materiaCursoPeriodoID = model?.materiaCursoPeriodoID ?? 0;
    this.fecha = model?.fecha ? moment(model.fecha).format('YYYY-MM-DD') : '';
    this.motivo = model?.motivo ?? '';
    this.horas = model?.horas ?? 0;
    this.isActive = model?.isActive ?? true;
  }
  id: number;
  unidadID: number;
  materiaCursoPeriodoID: number;
  fecha: string;
  motivo: string;
  horas: number;
  isActive: boolean;
}

export interface ClasePerdidaModalData {
  materias$: Observable<MateriaMin[]>;
  idUnidad: number;
}

export class ClasePerdidaForm {
  constructor(clasePerdida?: ClasePerdida) {
    this.id = clasePerdida?.id ?? 0;
    this.unidadID = clasePerdida?.unidadID ?? 0;
    this.materiaCursoPeriodoID = [clasePerdida?.materiaCursoPeriodoID ?? null, Validators.required];
    this.fecha = [formatDate(clasePerdida?.fecha ?? new Date(), 'yyyy-MM-dd', 'es_CO'), Validators.required];
    this.motivo = [clasePerdida?.motivo ?? '', Validators.required];
    this.horas = [clasePerdida?.horas ?? 1, Validators.required];
  }
  id: number = 0;
  unidadID: number;
  materiaCursoPeriodoID: [number, Validators] = [null, Validators.required];
  fecha: [string, Validators] = [formatDate(new Date(), 'yyyy-MM-dd', 'es_CO'), Validators.required];
  motivo: [string, Validators] = ['', Validators.required];
  horas: [number, Validators] = [1, Validators.required];
}


